import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
const exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('ChatExercise', LATEST_SCHEMA_VERSION.ChatExercise);
export default exerciseTypeVersionAdapter;